module.exports = __webpack_public_path__ + "img/invert_yellow.e1912125.webp";